import type { EventListResponse } from '@/types'

const MOCK_EVENTS_DATA: EventListResponse['items'] = [
  {
    id: 1,
    node_id: 'aaaaaaaa-0002-0002-0002-000000000002',
    command_id: null,
    level: 'warning',
    message: 'Heartbeat overdue by 90s',
    payload: null,
    created_at: new Date(Date.now() - 90000).toISOString(),
  },
  {
    id: 2,
    node_id: 'aaaaaaaa-0004-0004-0004-000000000004',
    command_id: null,
    level: 'error',
    message: 'Node offline — no heartbeat for 60m',
    payload: null,
    created_at: new Date(Date.now() - 3600000).toISOString(),
  },
  {
    id: 3,
    node_id: 'aaaaaaaa-0002-0002-0002-000000000002',
    command_id: 'cccccccc-0002-0002-0002-000000000002',
    level: 'error',
    message: 'Upload failed: connection reset',
    payload: { exit_code: 1 },
    created_at: new Date(Date.now() - 7000000).toISOString(),
  },
  {
    id: 4,
    node_id: 'aaaaaaaa-0001-0001-0001-000000000001',
    command_id: null,
    level: 'info',
    message: 'Recording started',
    payload: null,
    created_at: new Date(Date.now() - 600000).toISOString(),
  },
  {
    id: 5,
    node_id: 'aaaaaaaa-0003-0003-0003-000000000003',
    command_id: null,
    level: 'warning',
    message: 'Disk usage above 80% threshold',
    payload: { disk_percent: 82.4 },
    created_at: new Date(Date.now() - 1800000).toISOString(),
  },
]

export function mockEvents(params?: {
  node_id?: string
  level?: string
  command_id?: string
  since?: string
  limit?: number
  offset?: number
}): EventListResponse {
  let items = MOCK_EVENTS_DATA
  if (params?.node_id) items = items.filter((e) => e.node_id === params.node_id)
  if (params?.command_id) items = items.filter((e) => e.command_id === params.command_id)
  if (params?.level) {
    // support comma-separated levels e.g. "error,warning"
    const levels = params.level.split(',').map((l) => l.trim())
    items = items.filter((e) => levels.includes(e.level))
  }
  if (params?.since) {
    const since = new Date(params.since).getTime()
    items = items.filter((e) => new Date(e.created_at).getTime() >= since)
  }
  const total = items.length
  const offset = params?.offset ?? 0
  if (offset) items = items.slice(offset)
  if (params?.limit != null) items = items.slice(0, params.limit)
  return { items, total }
}
